import { IBaseAdConfig } from 'redux-state/advertisement/types.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { getWindow } from 'utilities/window.js';

/** Use interstitial override if present on the Server Side Include */
export const getInterstitalAdLayout = (
  interstitial: IBaseAdConfig | undefined,
  log?: boolean,
): IBaseAdConfig | undefined => {
  /** window adInterstitialLayoutOverride could be null in which case remove that in the config */
  const interstitialLayout = getWindow()?.adInterstitialLayoutOverride;
  if (interstitialLayout) {
    const updatedInterstial: IBaseAdConfig | undefined = interstitial
      ? { ...interstitial, ...{ layout: interstitialLayout } }
      : undefined;
    if (log) {
      messageLog.info('Overidden Ad Interstitial Layout', ['updatedInterstial', updatedInterstial]);
    }
    return updatedInterstial;
  }
  return interstitial;
};
